export default "__VITE_ASSET__BYMYBzUS__"